import { inject, Injectable } from '@angular/core';
import { forkJoin, map, Observable, of } from 'rxjs';
import { SupplierSegmentationApi } from '../api/supplier-segmentation.api';
import {
  SegmentParentOperation,
  SupplierSegmentation,
} from '../models/segment-parent.model';

@Injectable({ providedIn: 'root' })
export class SupplierSegmentationService {
  private readonly _segmentationApi = inject(SupplierSegmentationApi);

  public segmentParents(companyId: number): Observable<SupplierSegmentation> {
    return this._segmentationApi.segmentParents(companyId);
  }

  public updateSegmentParents(
    companyId: number,
    operations: SegmentParentOperation[],
  ): Observable<boolean> {
    if (!operations.length) return of(true);

    return forkJoin(
      operations.map((operation) =>
        this._segmentationApi.updateSegmentParent(operation.parentId, {
          path: '/accessibleSupplierIds',
          supId: companyId,
          locales: operation.locales,
          action: operation.action,
        }),
      ),
    ).pipe(map(() => true));
  }
}
